import { render, staticRenderFns } from "./calification.vue?vue&type=template&id=57a86f70"
import script from "./calification.vue?vue&type=script&lang=js"
export * from "./calification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports